import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SubscriptionStatus } from '../enums';
import { SelectItem } from '@web/shared/ui';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionStatusProviderService {
  private readonly entries = new Map<SubscriptionStatus, string>([
    [SubscriptionStatus.Cancelled, 'Anulowana'],
    [SubscriptionStatus.Active, 'Aktywna'],
    [SubscriptionStatus.Suspended, 'Wstrzymana'],
  ]);

  public labelFor(status: SubscriptionStatus): Observable<string> {
    const result = this.entries.get(status);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The entry for "${status}" is not found.`,
      );
    }

    return of(result);
  }

  public selectItems(): Observable<SelectItem<SubscriptionStatus>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([status, label]) => new SelectItem<SubscriptionStatus>(label, status),
      ),
    );
  }
}
